import { Button } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSafe } from '../../../shared/utility';
import { DASHBOARD_EPR_TARGETS } from '../../../shared/const/Routes/statePaths';
import { DataGrid } from '@mui/x-data-grid';
import LoadingOverlay from '../../../components/UI/LoadingOverlay/LoadingOverlay';
import { runEPR } from '../../../store/actions/dashboard/dashboard';

const columns = onRunClick => [
  {
    field: 'TargetName',
    headerName: 'Target Name',
    flex: 2,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'TargetFrequency',
    headerName: 'Target Frequency',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'coreConfiguration',
    headerName: 'Core Config',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'emulationTech',
    headerName: 'Emulation Technology',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'Ingredients',
    headerName: 'Ingredients',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'run',
    headerName: 'Execute Job',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: params => (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={e => {
          e.stopPropagation();
          onRunClick(params.row);
        }}
      >
        Run
      </Button>
    ),
  },
];

const TargetsTable = ({ loading, detailsRow }) => {
  const dispatch = useDispatch();
  const rows = useSelector(state => getSafe(DASHBOARD_EPR_TARGETS, state));

  const handleRunClick = row => {
    dispatch(
      runEPR(
        detailsRow.ReleasePath,
        detailsRow.ReleaseSetupCommand,
        row.TargetRunCommand
      )
    );
  };

  return (
    <LoadingOverlay loading={loading}>
      <DataGrid
        rows={rows}
        columns={columns(handleRunClick)}
        getRowId={row => row.TargetId}
        hideFooter
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
      />
    </LoadingOverlay>
  );
};

export default TargetsTable;
